/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum ChipInputTypeEnum {
    TEXT = 'TEXT',
    AUTOCOMPLETE = 'AUTOCOMPLETE'
}
